





























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { SalesContactSchema } from "@/models/sales_contact_schema";
import { Validations } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import CustomerService from "@/services/customer_service";
import { Validation } from "vuelidate";
import { CustomerSchema } from "@/models/customer_schema";
import { StoreModule } from "@/store/types";
import { CustomerActions } from "@/store/modules/customer/types";
import { namespace } from "vuex-class";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import { EventBus } from "@/events";

@Component
export default class SalesPerson extends Vue {
  protected $v: Validation;
  protected contacts = [] as SalesContactSchema[];
  protected customerService = new CustomerService();
  protected forDeletion: number[] = [];
  protected validated = false;
  @Prop() data!: CustomerSchema;
  @(namespace(StoreModule.Customer).Action(CustomerActions.EditCustomer))
  editCustomer;
  @Validations()
  validations() {
    return {
      contacts: {
        $each: {
          first_name: {
            required,
          },
          last_name: {
            required,
          },
          email: {
            required,
            email,
          },
        },
      },
    };
  }

  created() {
    const data =
      this.data.sales_contacts && this.data.sales_contacts.length > 0
        ? JSON.parse(JSON.stringify(this.data.sales_contacts)) // deep clone
        : [];
    this.contacts = data;
  }

  public async handleSubmit(): Promise<void> {
    this.validated = false;
    if (this.contacts.length < 1) {
      this.$emit("close");
    } else if (this.forDeletion.length < 1) {
      this.validateNoDelete();
    } else {
      await this.validateDelete();
    }
  }

  /**
   *
   * contactsCopy is neccessary so not to affect the view, which is tied to this.contacts.
   *
   * If there is atleast one item up for deletion, iterate through all contacts.
   * Need to check if delete checkbox is checked before validating fields (empty/invalid
   * fields may be marked for deletion, so we don't want to those fields to incorrectly
   * prevent submission, because they will be invalid on the $v object).
   *
   * If marked for deletion, remove from array.
   *
   */
  public async validateDelete(): Promise<void> {
    this.validated = true;
    const contactsCopy = [ ...this.contacts ];
    for (const [index, contact] of this.contacts.entries()) {
      if (!this.forDeletion.includes(index)) {
        this.$v.contacts.$each.$iter[index].$touch();
        if (this.$v.contacts.$each.$iter[index].$invalid) {
          this.validated = false; // Form will not submit if any of the items switch boolean to false
        }
      } else {
        contactsCopy.splice(index, 1);
      }
    }
    if (this.validated) {
      this.submitForm(contactsCopy);
    }
  }

  public async updateContacts(contacts: SalesContactSchema[]): Promise<void> {
    try {
      const newData = { ...this.data };
      newData.sales_contacts = contacts;
      await this.customerService.updateCustomer(newData, this.data._id);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  public validateNoDelete(): void {
    this.$v.contacts.$touch();
    if (!this.$v.$invalid) {
      this.validated = true;
      this.submitForm(this.contacts);
    }
  }

  public async submitForm(contacts: SalesContactSchema[]): Promise<void> {
    this.updateContacts(contacts);
    EventBus.$emit("updateCustomer");
    this.$emit("close");
  }

  public addSalesPerson(): void {
    const contact = {
      first_name: "",
      last_name: "",
      email: "",
    };
    this.contacts.push(contact);
  }
}
